import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { Row, Col, Table, Icon } from "antd";
import moment from "moment";

import ButtonStandard from "../../../../../../components/utils/button";
import { getAnimalLotHistory } from "../../../../../../services/animalHistoryService";
import { numberMask } from "../../../../../../services/helpersMethodsService";
import { logEventError } from "../../../../../../utils/logger";

function TabAnimalLotHistory() {
  const [loading, setLoading] = useState(false);
  const [lotHistoryData, setLotHistoryData] = useState([]);

  const {
    app: {
      translation,
      groupSelected: { id: groupId },
      farmSelected: { id: farmId },
    },
  } = useSelector((state) => state);

  const {
    params: { id: animalId },
  } = useRouteMatch();

  const columns = [
    {
      title: translation.animal.details.animalHistory.lotName,
      width: 120,
      dataIndex: "lotName",
      key: "lotName",
      render: (text) => text || "-",
    },
    {
      title: translation.animal.details.animalHistory.activity,
      width: 100,
      dataIndex: "productionSubSystem",
      key: "productionSubSystem",
      render: (text) => translation.productionSubSystem[text] || "-",
    },
    {
      title: translation.animal.details.animalHistory.dietStrategy,
      width: 130,
      dataIndex: "dietStrategyName",
      key: "dietStrategyName",
      render: (text) => text || "-",
    },
    {
      title: translation.animal.details.animalHistory.entryDate,
      width: 120,
      dataIndex: "lotDateIn",
      key: "lotDateIn",
      render: (date) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      title: translation.animal.details.animalHistory.exitDate,
      width: 120,
      dataIndex: "lotDateOut",
      key: "lotDateOut",
      render: (date) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      title: translation.animal.details.animalHistory.daysQuantity,
      width: 100,
      dataIndex: "amountDays",
      key: "amountDays",
      render: (text) => `${text} dias`,
    },
    {
      title: translation.animal.details.animalHistory.weightIn,
      width: 100,
      dataIndex: "weightIn",
      key: "weightIn",
      render: (weight) =>
        weight ? `${numberMask(weight || 0, false)} kg` : "-",
    },
    {
      title: translation.animal.details.animalHistory.weightOut,
      width: 100,
      dataIndex: "weightOut",
      key: "weightOut",
      render: (weight) =>
        weight ? `${numberMask(weight || 0, false)} kg` : "-",
    },
  ];

  const fetchLotHistory = async () => {
    setLoading(true);
    try {
      const response = await getAnimalLotHistory({ groupId, farmId, animalId });
      setLotHistoryData(response.data.results);
    } catch (error) {
      logEventError("Erro ao buscar histórico de lotes:", error);
      setLotHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLotHistory();
  }, [groupId, farmId, animalId]);

  const handleRefresh = () => {
    fetchLotHistory();
  };

  return (
    <div>
      <Row type="flex" justify="end" style={{ marginBottom: 16 }}>
        <Col>
          <ButtonStandard buttonType="secondary" onClick={handleRefresh}>
            <Icon type="reload" /> {translation.buttons.updateTable}
          </ButtonStandard>
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={lotHistoryData}
        loading={loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} de ${total} itens`,
          hideOnSinglePage:
            lotHistoryData !== null && lotHistoryData.length > 10
              ? false
              : true,
        }}
        scroll={{ x: true }}
      />
    </div>
  );
}

export default TabAnimalLotHistory;
